import * as actionTypes from '../actions/actionTypes';
import L from 'leaflet';
import {updateObject, arrayMove, percentageToHsl, hslToHex} from '../utilities';

const initialState = {
    mapBounds: [[39.1, 45.3],[42.7, 51.1]],
    mapLayers:[
        {
            group_id:2,
            group:"",
            bounds:[],
            type:"polygon",
            label:"LAU1",
            tableName:"lau1",
            zIndex:5,
            visible:false,
            connection:"wms",
            style:{},
            data:{layer:"burned_areas:lau1"},
            viewparams:"",
            layerOpacity:1,
            displayLegend: false,
            layerProperties: {
                "areasqkm":"Έκταση (τετραγωνικά χιλιόμετρα)",
                "l1_code":"Κωδικός Δήμου/Κοινότητας (ΕΛΣΤΑΤ)",
                "l1_name1el":"Δήμος/Κοινότητα (LAU1) [Επίσημη ονομασία]",
                "l1_name2el":"Δήμος/Κοινότητα (LAU1) [Κοινή ονομασία]",
                "n3_name4el":"Περιφερειακή Ενότητα (NUTS3)",
                "n2_name4el":"Περιφέρεια (NUTS2)",
                "n1_name4el":"Μεγάλη Γεωγραφική Περιοχή (NUTS1)",
            }
        },
        {
            group_id:2,
            group:"",
            bounds:[],
            type:"polygon",
            label:"NUTS3",
            tableName:"nuts3",
            zIndex:4,
            visible:false,
            connection:"wms",
            style:{},
            data:{layer:"burned_areas:nuts3"},
            viewparams:"",
            layerOpacity:1,
            displayLegend: false,
            layerProperties: {
                "areasqkm":"Έκταση (τετραγωνικά χιλιόμετρα)",
                "n3_name4el":"Περιφερειακή Ενότητα (NUTS3)",
                "n2_name4el":"Περιφέρεια (NUTS2)",
                "n1_name4el":"Μεγάλη Γεωγραφική Περιοχή (NUTS1)",
            }
        },
        {
            group_id:2,
            group:"",
            bounds:[],
            type:"polygon",
            label:"NUTS2",
            tableName:"nuts2",
            zIndex:3,
            visible:false,
            connection:"wms",
            style:{},
            data:{layer:"burned_areas:nuts2"},
            viewparams:"",
            layerOpacity:1,
            displayLegend: false,
            layerProperties: {
                "areasqkm":"Έκταση (τετραγωνικά χιλιόμετρα)",
                "n2_name4el":"Περιφέρεια (NUTS2)",
                "n1_name4el":"Μεγάλη Γεωγραφική Περιοχή (NUTS1)",
            }
        },
        {
            group_id:2,
            group:"",
            bounds:[],
            type:"polygon",
            label:"NUTS1",
            tableName:"nuts1",
            zIndex:2,
            visible:false,
            connection:"wms",
            style:{},
            data:{layer:"burned_areas:nuts1"},
            viewparams:"",
            layerOpacity:1,
            displayLegend: false,
            layerProperties: {
                "areasqkm":"Έκταση (τετραγωνικά χιλιόμετρα)",
                "n1_name4el":"Μεγάλη Γεωγραφική Περιοχή (NUTS1)",
            }
        },
        {
            group_id:3,
            group:"",
            bounds:[],
            type:"polygon",
            label:"Corine Land Cover",
            tableName:"clc",
            zIndex:1,
            visible:false,
            connection:"wms",
            style:{
                type:"multiple",
                field:"clc_code",
                classes:[
                    {
                        label:"111: Συνεχής αστικός ιστός",
                        style:{
                            fillColor:"#e6004d",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"112: Ασυνεχής αστικός ιστός",
                        style:{
                            fillColor:"#ff0000",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"121: Βιοµηχανικές και εµπορικές ζώνες",
                        style:{
                            fillColor:"#cc4df2",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"122: Οδικά και σιδηροδροµικά δίκτυα",
                        style:{
                            fillColor:"#cc0000",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"123: Ζώνες λιµένων",
                        style:{
                            fillColor:"#e6cccc",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"124: Αεροδρόµια",
                        style:{
                            fillColor:"#e6cce6",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"131: Χώροι εξορύξεως ορυκτών",
                        style:{
                            fillColor:"#a600cc",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"132: Χώροι απορρίψεως απορριµµάτων",
                        style:{
                            fillColor:"#a64d00",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"133: Χώροι οικοδόµηση",
                        style:{
                            fillColor:"#ff4dff",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"141: Περιοχές αστικού πρασίνου",
                        style:{
                            fillColor:"#ffa6ff",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"142: Εγκαταστάσεις αθλητισµού και αναψυχής",
                        style:{
                            fillColor:"#ffe6ff",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"211: Μη αρδευόµενη αρόσιµη γη",
                        style:{
                            fillColor:"#ffffa8",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"212: Μόνιµα αρδευόµενη γη",
                        style:{
                            fillColor:"#ffff00",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"213: Ορυζώνες",
                        style:{
                            fillColor:"#e6e600",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"221: Αµπελώνες",
                        style:{
                            fillColor:"#e68000",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"222: Οπωροφόρα δένδρα και φυτείες µε σαρκώδεις καρπούς",
                        style:{
                            fillColor:"#f2a64d",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"223: Ελαιώνες",
                        style:{
                            fillColor:"#e6a600",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"231: Λιβάδια",
                        style:{
                            fillColor:"#e6e64d",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"241: Ετήσιες καλλιέργειες που σχετίζονται µε µόνιµες καλλιέργειες",
                        style:{
                            fillColor:"#ffe6a6",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"242: Σύνθετες καλλιέργειες",
                        style:{
                            fillColor:"#ffe64d",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"243: Γη που χρησιµοποιείται κυρίως για γεωργία µαζί µε σηµαντικά τµήµατα φυσικής βλάστησης",
                        style:{
                            fillColor:"#e6cc4d",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"244: Γεωργο-δασικές περιοχές",
                        style:{
                            fillColor:"#f2cca6",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"311: ∆άσος πλατύφυλλων",
                        style:{
                            fillColor:"#80ff00",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"312: ∆άσος κωνοφόρων",
                        style:{
                            fillColor:"#00a600",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"313: Μικτό δάσος",
                        style:{
                            fillColor:"#4dff00",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"321: Φυσικοί βοσκότοποι",
                        style:{
                            fillColor:"#ccf24d",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"322: Θάµνοι και χερσότοποι",
                        style:{
                            fillColor:"#a6ff80",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"323: Σκληροφυλλική βλάστηση",
                        style:{
                            fillColor:"#a6e64d",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"324: Μεταβατικές δασώδεις και θαµνώδεις εκτάσεις",
                        style:{
                            fillColor:"#a6f200",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"331: Παραλίες, αµµόλοφοι, αµµουδιές",
                        style:{
                            fillColor:"#e6e6e6",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"332: Απογυµνωµένοι βράχοι",
                        style:{
                            fillColor:"#cccccc",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"333: Εκτάσεις µε αραιή βλάστηση",
                        style:{
                            fillColor:"#ccffcc",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"334: Αποτεφρωµένες εκτάσεις",
                        style:{
                            fillColor:"#000000",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"335: Παγετώνες και αέναο χιόνι",
                        style:{
                            fillColor:"#a6e6cc",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"411: Βάλτοι στην ενδοχώρα",
                        style:{
                            fillColor:"#a6a6ff",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"412: Τυρφώνες",
                        style:{
                            fillColor:"#4d4dff",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"421: Παραθαλάσσιοι βάλτοι",
                        style:{
                            fillColor:"#ccccff",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"422: Αλυκές",
                        style:{
                            fillColor:"#e6e6ff",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"423: Ζώνες που καλύπτονται από παλιρροιακά ύδατα",
                        style:{
                            fillColor:"#a6a6e6",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"511: Υδατορρεύµατα",
                        style:{
                            fillColor:"#00ccf2",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"512: Επιφάνειες στάσιµου ύδατος",
                        style:{
                            fillColor:"#80f2e6",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"521: Παράκτιες λιµνοθάλασσες",
                        style:{
                            fillColor:"#00ffa6",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"522: Εκβολές ποταµών",
                        style:{
                            fillColor:"#a6ffe6",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"523: Θάλασσες και ωκεανοί",
                        style:{
                            fillColor:"#e6f2ff",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    },{
                        label:"999: Χωρίς δεδομένα",
                        style:{
                            fillColor:"#ffffff",
                            fillOpacity:1,
                            color:"#000000",
                            opacity:0,
                            weight:1
                        }
                    }
                ]
            },
            data:{layer:"burned_areas:clc"},
            viewparams:"",
            layerOpacity:0.7,
            displayLegend: false,
            layerProperties: {
                "id":"Αναγνωριστικό πολυγώνου",
                "area_ha":"Έκταση (εκτάρια)",
                "clc_code":"Κωδικός (τρίτο επίπεδο)",
                "l1_name1el":"Πρώτο επίπεδο",
                "l2_name1el":"Δεύτερο επίπεδο",
                "l3_name1el":"Τρίτο επίπεδο",
            }
        }
    ],
    mapLayersRaster:[],
    tableData: null,
    searchResultItem: null,
    mapLayersLoading:[],
    queryMapLayers:[],
    queryMapLayersLoading:[],
    mapKey:null,
    grazingLayers:[],
    grazingYears:[],
    fireYears: [],
    mapLayersFiresPolygons:[],
    mapLayersFiresPoints:[]
};

const updateMapBounds = (state, action) => {
    return updateObject(state, {
        mapBounds:action.mapBounds
    });
}

const updateLayerVisibility = (state, action) => {
    let newLayers = [...state[action.collection]];
    newLayers[action.layerIndex].visible = !newLayers[action.layerIndex].visible;

    return updateObject(state,{
        [action.collection]:newLayers
    });
}

const updateLayerFillColor = (state, action) => {
    const r = action.fillColor.r
    const g = action.fillColor.g
    const b = action.fillColor.b
    const a = action.fillColor.a

    let newLayers = [...state[action.collection]];
    newLayers[action.layerIndex].style.fillColor = "rgba(" + r + "," + g + "," + b + "," + a + ")";

    return updateObject(state,{
        [action.collection]:newLayers
    });
}

const updateLayerBorderColor = (state, action) => {
    const r = action.borderColor.r
    const g = action.borderColor.g
    const b = action.borderColor.b
    const a = action.borderColor.a

    let newLayers = [...state[action.collection]];
    newLayers[action.layerIndex].style.color = "rgba(" + r + "," + g + "," + b + "," + a + ")";

    return updateObject(state,{
        [action.collection]:newLayers
    });
}

const updateLayerBorderWidth = (state, action) => {
    let newLayers = [...state[action.collection]];
    newLayers[action.layerIndex].style.weight = action.event.target.value;
 
    return updateObject(state,{
        [action.collection]:newLayers
    });
}

const updateMapLayersOrder = (state,action) => {
    let newLayers = [...state[action.collection]];
    arrayMove(newLayers, action.event.oldIndex, action.event.newIndex);

    return updateObject(state,{
        [action.collection]:newLayers
    });
}

const updateMapTable = (state, action) => {
    const tableData = state[action.collection][action.layerIndex].data;

    return updateObject(state,{
        tableData: tableData
    });
}

const removeLayerItem = (state, action) => {
    let newLayers = [...state[action.collection]];
    newLayers.splice(action.layerIndex, 1);

    return updateObject(state,{
        [action.collection]:newLayers
    });
}

const showSearchResultItem = (state, action) => {
    return updateObject(state,{
        searchResultItem:action.searchResultItem,
        mapBounds:[[action.searchResultItem.y,action.searchResultItem.x],[action.searchResultItem.y,action.searchResultItem.x]]
    });
}

const clearSearchResultItem = (state) => {
    return updateObject(state,{
        searchResultItem:null
    });
}

const updateLayerViewparams = (state,action) => {
    let mapLayers = [...state.mapLayers];
    mapLayers[action.mapLayerIndex].viewparams = action.viewparams;

    return updateObject(state, {mapLayers:mapLayers});
}

const addLayerLoading = (state,action) => {
    let layersLoading = [...state[action.collection]];
    layersLoading.push(action.mapLayerIndex);

    return updateObject(state, {[action.collection]:layersLoading});
}

const removeLayerLoading = (state,action) => {
    let layersLoading = [...state[action.collection]];

    const index = layersLoading.indexOf(action.mapLayerIndex);
    if (index !== -1) {
        layersLoading.splice(index, 1);
    }

    return updateObject(state, {[action.collection]:layersLoading});
}

const getMapLayersStarted = (state) => {
    return updateObject(state, {loading:true});
}

const getMapLayersSuccess = (state,action) => {
    let mapLayersRaster = [];
    let grazingYears = [];

    action.mapLayers.map_layers.forEach(mapLayer => {
        if (mapLayer.data_format === 'Raster'){
            mapLayersRaster.push(mapLayer);
        }

        // Insert all available years for the user for grazing in an array
        if (mapLayer.subgroup === 'Grazing capacity'){
            let year = mapLayer.raster_filename.split('_')[4];
            let yearIndex = grazingYears.findIndex(grazingYear => grazingYear.value === year);

            if (yearIndex === -1){ //the year has not been added to the array
                grazingYears.push({value:year, label:year});
            }
        }
    });

    // sort array with years ascending
    grazingYears.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));

    return updateObject(state, {
        error:false,
        loading:false,
        mapLayers:action.mapLayers.map_layers,
        mapLayersRaster:mapLayersRaster,
        grazingYears:grazingYears
    });
}

const getMapLayersFailed = (state) => {
    return updateObject(state, {error:true,loading:false});
}

const updateMapLayersStarted = (state) => {
    return updateObject(state, {loading:true});
}

const updateMapLayersSuccess = (state,action) => {
    return updateObject(state, {
        error:false,
        loading:false,
        mapLayers:action.mapLayers.map_layers
    });
}

const updateMapLayersFailed = (state) => {
    return updateObject(state, {error:true,loading:false});
}

const saveQueryResultSuccess = (state,action) => {
    let queryMapLayers = [...state.queryMapLayers];

    let boundsLayer = JSON.parse(action.boundingBox.features[0].properties.bounds);
    let bounds = L.geoJSON(boundsLayer).getBounds();

    const layer = action.payload.geoserverWorkspace + ":" + action.payload.selectedQueryLayer.tableName;

    let filter = "";
    let name = "";

    if (action.payload.selectedQueryField.dataType === "string"){
        filter = action.payload.selectedQueryField.field + "='" + action.payload.selectedQueryValue + "'";
        name = action.payload.selectedQueryLayer.label + ": " + action.payload.selectedQueryField.field + " = " + action.payload.selectedQueryValue;
    } else {
        let min = action.payload.selectedQueryValue[0];
        let max = action.payload.selectedQueryValue[1];

        filter = "(" + action.payload.selectedQueryField.field + ">=" + min + " AND " + action.payload.selectedQueryField.field + "<=" + max + ")";
        name = action.payload.selectedQueryLayer.label + ": " + min + " <= " + action.payload.selectedQueryField.field + " >= " + max;
    }
    
    queryMapLayers.push(
        {
            data:{layer: layer}, // Geojson or connection parameters for wms
            name: name,
            group_id: null,
            group: "queries",
            published: true,
            downloads: false,
            bounds: bounds,
            geoserver_url: action.payload.geoserverUrl,
            connection: "wms",
            visible: true,
            viewparams: "",
            filter: filter,
            layerOpacity: 1,
            type: "raster",
            style: {}
        }
    )

    return updateObject(state, {queryMapLayers:queryMapLayers});
}

const updateMapKey = (state) => {
    var d = new Date();

    return updateObject(state, {mapKey:d.getMilliseconds()});
}

const changeLayerOpacity = (state, action) => {
    let layers = [...state[action.collection]];
    layers[action.layerIndex].layerOpacity = action.percentage / 100;

    return updateObject(state, {[action.collection]:layers});
}

const getFireYearsSuccess = (state, action) => {
    let fireYears = [];
    let mapLayers = [...state.mapLayers];
    const colors = ["007fff","178be7","2e96d0","45a2b9","5cada1","73b98a","8ac473","a2d05c","add650","b9dc45","cae433","dced22","edf611","ffff00","fce502","f9cb05","f9b005","f4970a","f17e0c","ef640f","ec4a11","e93014","e71717","a21010","850d0d"]
    let colorIndex = 0;
    let color = "";

    let mapLayersFiresPolygons = [];
    let mapLayersFiresPoints = [];

    action.fireYears.features.forEach((fireYear,index) => {
        fireYears.push(fireYear.properties.fire_year);

        // Calculate color between green(120) and red(0)
        colorIndex = Math.floor(index * ((colors.length - 1) / (action.fireYears.features.length - 1)));
        color = colors[colorIndex];
        
        mapLayersFiresPolygons.push({
            group_id:1,
            group:"",
            bounds:[],
            type:"polygon",
            label:fireYear.properties.fire_year,
            tableName:"fires",
            zIndex:6 + index,
            visible:true,
            connection:"wms",
            style:{
                type:"single",
                env: color
            },
            data:{layer:"burned_areas:fires_per_year"},
            viewparams:"YEAR:" + fireYear.properties.fire_year,
            layerOpacity:1,
            displayLegend: true,
            layerProperties: {
                "year":"Έτος",
                "datestart":"Ημερομηνία έναρξης πυρκαγιάς",
                "dates2post":"Ημερομηνία λήψης εικόνας Sentinel-2",
                "nuts2":"Περιφέρεια (NUTS2)",
                "nuts3":"Περιφερειακή Ενότητα (NUTS3)",
                "lau1":"Δήμος/Κοινότητα (LAU1)",
                "location":"Θέση",
                "foroffice":"Δασαρχείο",
                "fordirect":"Διεύθυνση Δασών",
                "linkmap":"Σύνδεσμός χάρτη",
                "areaha":"Καμένη έκταση (εκτάρια)",
                "domclass":"Κυριάρχος τύπος κάλυψης γης εντός της περιμέτρου (CORINE LC 2018)",
                "taclc1":"Τεχνητές επιφάνειες (CLC2018, Κωδικός: 1)",
                "taclc2":"Γεωργικές περιοχές (CLC2018, Κωδικός: 2)",
                "taclc311":"∆άσος πλατύφυλλων (CLC2018, Κωδικός: 311)",
                "taclc312":"∆άσος κωνοφόρων (CLC2018, Κωδικός: 312)",
                "taclc313":"Μικτό δάσος (CLC2018, Κωδικός: 313)",
                "taclc321":"Φυσικοί βοσκότοποι (CLC2018, Κωδικός: 321)",
                "taclc322":"Θάµνοι και χερσότοποι (CLC2018, Κωδικός: 322)",
                "taclc323":"Σκληροφυλλική βλάστηση (CLC2018, Κωδικός: 323)",
                "taclc324":"Μεταβατικές δασώδεις και θαµνώδεις εκτάσεις (CLC2018, Κωδικός: 324)",
                "taclc33":"Ανοιχτοί χώροι µε λίγη ή καθόλου βλάστηση (CLC2018, Κωδικός: 33)",
                "taclc4":"Υγρότοποι (CLC2018, Κωδικός: 4)",
                "taclc5":"Υδάτινες επιφάνειες (CLC2018, Κωδικός: 5)"
            }
        })

        mapLayersFiresPoints.push({
            group_id:1,
            group:"",
            bounds:[],
            type:"polygon",
            label:fireYear.properties.fire_year,
            tableName:"fires",
            zIndex:6 + index,
            visible:true,
            connection:"wms",
            style:{
                type:"single",
                env: color
            },
            data:{layer:"burned_areas:fires_per_year_points"},
            viewparams:"YEAR:" + fireYear.properties.fire_year,
            layerOpacity:1,
            displayLegend: true,
            layerProperties: {
                "year":"Έτος",
                "datestart":"Ημερομηνία έναρξης πυρκαγιάς",
                "dates2post":"Ημερομηνία λήψης εικόνας Sentinel-2",
                "nuts2":"Περιφέρεια (NUTS2)",
                "nuts3":"Περιφερειακή Ενότητα (NUTS3)",
                "lau1":"Δήμος/Κοινότητα (LAU1)",
                "location":"Θέση",
                "foroffice":"Δασαρχείο",
                "fordirect":"Διεύθυνση Δασών",
                "linkmap":"Σύνδεσμός χάρτη",
                "areaha":"Καμένη έκταση (εκτάρια)",
                "domclass":"Κυριάρχος τύπος κάλυψης γης εντός της περιμέτρου (CORINE LC 2018)",
                "taclc1":"Τεχνητές επιφάνειες (CLC2018, Κωδικός: 1)",
                "taclc2":"Γεωργικές περιοχές (CLC2018, Κωδικός: 2)",
                "taclc311":"∆άσος πλατύφυλλων (CLC2018, Κωδικός: 311)",
                "taclc312":"∆άσος κωνοφόρων (CLC2018, Κωδικός: 312)",
                "taclc313":"Μικτό δάσος (CLC2018, Κωδικός: 313)",
                "taclc321":"Φυσικοί βοσκότοποι (CLC2018, Κωδικός: 321)",
                "taclc322":"Θάµνοι και χερσότοποι (CLC2018, Κωδικός: 322)",
                "taclc323":"Σκληροφυλλική βλάστηση (CLC2018, Κωδικός: 323)",
                "taclc324":"Μεταβατικές δασώδεις και θαµνώδεις εκτάσεις (CLC2018, Κωδικός: 324)",
                "taclc33":"Ανοιχτοί χώροι µε λίγη ή καθόλου βλάστηση (CLC2018, Κωδικός: 33)",
                "taclc4":"Υγρότοποι (CLC2018, Κωδικός: 4)",
                "taclc5":"Υδάτινες επιφάνειες (CLC2018, Κωδικός: 5)"
            }
        })
    });

    const showMapLayers = [...mapLayers, ...mapLayersFiresPoints];

    return updateObject(state, {fireYears:fireYears, mapLayers:showMapLayers, mapLayersFiresPolygons:mapLayersFiresPolygons, mapLayersFiresPoints:mapLayersFiresPoints});
}

const showFirePolygons = (state) => {
    let mapLayers = [...state.mapLayers];
    const mapLayersFiresPolygons = [...state.mapLayersFiresPolygons];

    mapLayers.length = 5; // Remove all fires, which are the last items in mapLayers array

    const showMapLayers = [...mapLayers, ...mapLayersFiresPolygons];

    return updateObject(state, {mapLayers:showMapLayers});
}

const showFirePoints = (state) => {
    const mapLayers = [...state.mapLayers];
    const mapLayersFiresPoints = [...state.mapLayersFiresPoints];

    mapLayers.length = 5; // Remove all fires, which are the last items in mapLayers array

    const showMapLayers = [...mapLayers, ...mapLayersFiresPoints];

    return updateObject(state, {mapLayers:showMapLayers});
}

const toggleLegend = (state,action) => {
    let mapLayers = [...state.mapLayers];
    mapLayers[action.layerIndex].displayLegend = !mapLayers[action.layerIndex].displayLegend;

    return updateObject(state, {mapLayers:mapLayers});
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.UPDATE_LAYER_FILL_COLOR: return updateLayerFillColor(state, action);
        case actionTypes.UPDATE_MAP_BOUNDS: return updateMapBounds(state, action);
        case actionTypes.UPDATE_LAYER_VISIBILITY: return updateLayerVisibility(state, action);
        case actionTypes.UPDATE_LAYER_BORDER_COLOR: return updateLayerBorderColor(state, action);
        case actionTypes.UPDATE_LAYER_BORDER_WIDTH: return updateLayerBorderWidth(state, action);
        case actionTypes.UPDATE_MAP_LAYERS_ORDER: return updateMapLayersOrder(state, action);
        case actionTypes.UPDATE_MAP_TABLE: return updateMapTable(state, action);
        case actionTypes.REMOVE_LAYER_ITEM: return removeLayerItem(state, action);
        case actionTypes.SHOW_SEARCH_RESULT_ITEM: return showSearchResultItem(state, action);
        case actionTypes.CLEAR_SEARCH_RESULT_ITEM: return clearSearchResultItem(state);
        case actionTypes.UPDATE_LAYER_VIEWPARAMS: return updateLayerViewparams(state,action);
        case actionTypes.ADD_LAYER_LOADING: return addLayerLoading(state,action);
        case actionTypes.REMOVE_LAYER_LOADING: return removeLayerLoading(state,action);
        case actionTypes.GET_MAP_LAYERS_STARTED: return getMapLayersStarted(state);
        case actionTypes.GET_MAP_LAYERS_SUCCESS: return getMapLayersSuccess(state,action);
        case actionTypes.GET_MAP_LAYERS_FAILED: return getMapLayersFailed(state);
        case actionTypes.UPDATE_MAP_LAYERS_STARTED: return updateMapLayersStarted(state);
        case actionTypes.UPDATE_MAP_LAYERS_SUCCESS: return updateMapLayersSuccess(state,action);
        case actionTypes.UPDATE_MAP_LAYERS_FAILED: return updateMapLayersFailed(state);
        case actionTypes.SAVE_QUERY_RESULT_SUCCESS: return saveQueryResultSuccess(state,action);
        case actionTypes.UPDATE_MAP_KEY: return updateMapKey(state,action);
        case actionTypes.CHANGE_LAYER_OPACITY: return changeLayerOpacity(state,action);
        case actionTypes.GET_FIRE_YEARS_SUCCESS: return getFireYearsSuccess(state, action);
        case actionTypes.SHOW_FIRE_POLYGONS: return showFirePolygons(state);
        case actionTypes.SHOW_FIRE_POINTS: return showFirePoints(state);
        case actionTypes.TOGGLE_LEGEND: return toggleLegend(state,action);
        default: return state;
    }
};

export default reducer;